import { render } from "./FlowPanelElementText.vue?vue&type=template&id=4bed03ba&scoped=true&ts=true"
import script from "./FlowPanelElementText.vue?vue&type=script&lang=ts"
export * from "./FlowPanelElementText.vue?vue&type=script&lang=ts"

import "./FlowPanelElementText.vue?vue&type=style&index=0&id=4bed03ba&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bed03ba"]])

export default __exports__